import loadable from '@loadable/component';

export const CmsAmpHeroBlockLoadable = loadable(
  () => import('./CmsAmpHeroBlock'),
  { resolveComponent: (module) => module.CmsAmpHeroBlock },
);
